import { CodedException } from '@/core';
import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery<CodedException>(),
  tagTypes: ['user', 'projects'],
  endpoints: () => ({}),
});
